export const fieldsGoals = [
    {
        label:'Name' ,
        name:'name', 
        type:'text'
    }, 
    {
        label:'Description', 
        name:'description', 
        type:'text'
    }
];

export const fieldsCategories = [
    {
        label:'Description',
        name:'description', 
        type:'text'
    }
];

export const fieldsRequirements = [
    {
        label:'Description',
        name:'description', 
        type:'text'
    }
];

export const fieldsModules = [
    {
        label:'Type',
        name:'type', 
        type:'select', 
        values: 'types'
    }, 
    {
        label:'Details',
        name:'details', 
        type:'text'
    }
];

export const fieldsCertifications = [
    {
        label:'Title',
        name:'title', 
        type:'text'
    }, 
    {
        label:'Suffix',
        name:'suffix', 
        type:'text'
    }, 
    {
        label:'Valid in',
        name:'provinces', 
        type:'select', 
        values: 'provinces'
    }
];



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Fields.js